// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Section_elSection__28xOF {\n  margin-bottom: 16px; }\n\n.Section_elForm__1Ow52 .Section_securityField1__gePUJ {\n  max-width: calc(25% - 30px) !important;\n  min-width: calc(25% - 30px) !important; }\n\n.Section_otherField__shYHM {\n  margin-bottom: 24px !important; }\n", ""]);
// Exports
exports.locals = {
	"elSection": "Section_elSection__28xOF",
	"elForm": "Section_elForm__1Ow52",
	"securityField1": "Section_securityField1__gePUJ",
	"otherField": "Section_otherField__shYHM"
};
module.exports = exports;
